<template>
  <mu-card id="medication-input" class="aio-input">
    <mu-card-actions class="aio-input-header pointer" @click.native="openInput">
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="16px" height="16px" viewBox="21 193 15 15" version="1.1"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <path
              d="M1.00081633,9.15102041 C-0.331428571,10.4832653 -0.331428571,12.6546939 1.00081633,13.9869388 C2.33306122,15.3191837 4.5044898,15.3191837 5.83673469,13.9869388 L9.9477551,9.87591837 L5.11183673,5.03673469 L1.00081633,9.15102041 L1.00081633,9.15102041 Z"
              id="path-1"></path>
            <mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0"
                  width="9.94612245" height="9.94938776" fill="white">
              <use xlink:href="#path-1"></use>
            </mask>
          </defs>
          <g id="Group-5" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
             transform="translate(21.000000, 193.000000)">
            <path
              d="M9.15020408,1.00163265 L4.56897959,5.56979592 L9.40489796,10.4057143 L13.9828571,5.83428571 C15.3183673,4.50204082 15.3183673,2.33387755 13.9828571,1.00163265 C12.6506122,-0.333877551 10.482449,-0.333877551 9.15020408,1.00163265 Z"
              id="Shape" fill="#AD3463"></path>
            <use id="Shape" stroke="#AD3463" mask="url(#mask-2)" stroke-width="2" xlink:href="#path-1"></use>
          </g>
        </svg>
        <mu-flexbox-item class="left16" v-text="title"></mu-flexbox-item>
        <mu-flexbox-item align="right">
          <mu-icon-button
            v-tooltip.top="'Configure medications'"
            class="card-bar-icon blueIcon"
            icon="settings_cog"
            @click.native="goToSettings()"
          >
          </mu-icon-button>
          <mu-icon-button
            v-tooltip.top="$t('message.addEntryText')"
            v-if="hasMedications  && !isOpenInput"
            class="card-bar-icon blueIcon"
            :icon="'add_circle'"
          ></mu-icon-button>
          <mu-icon-button
            v-if="hasMedications && isOpenInput"
            class="card-bar-icon blueIcon"
            :icon="'remove_circle_outline'"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <form v-if="isOpenInput" novalidate>
      <mu-card-text v-if="hasMedications">
        <mu-select-field
          v-validate="'required'"
          data-vv-name="medication"
          data-vv-value-path="inputValue"
          :errorText="errors.first('medication')"
          data-vv-validate-on="none"
          :scroller="scroller"
          v-model="model.tracking_id"
          :label="$t('message.cardMedicationSelect')"
          :hintText="$t('message.selectText')"
          fullWidth
          autoWidth
        >
          <mu-menu-item
            v-for="item, index in medications"
            :title="item.treatment_name"
            :value="item.tracking_id"
            :key="'treatment-' + index"
          ></mu-menu-item>
        </mu-select-field>

        <mu-text-field
          class="bottom"
          min="1"
          max="1000"
          v-validate="'required|min_value:1|max_value:1000'"
          data-vv-name="dosage"
          data-vv-value-path="inputValue"
          :errorText="errors.first('dosage')"
          data-vv-validate-on="none"
          :label="$t('message.cardMedicationDose')"
          type="number"
          v-model.number="model.dosage"
          :hintText="$t('message.cardMedicationDosage')"
          :helpText="localizeRegime(activeLabel)"
          fullWidth
        >
        </mu-text-field>
      </mu-card-text>
    </form>
  </mu-card>
</template>
<script>

  import MedicationApi from '../../../../api/Tracking/Medication/index'
  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import MedicationRegimeMixin from '../../../../mixins/Localization/MedicationRegimes'

  export default {
    mixins: [ScrollerMixin, MedicationRegimeMixin],
    name: 'aio-medication',
    data() {
      return {
        title: this.$t('message.cardMedication'),
        isOpen: false,
        isOpenInput: false,
        hasMedications: true,
        data: {},
        medications: [],
        model: {
          tracking_id: null,
          dosage: null
        }
      }
    },
    watch: {
      'model.tracking_id': function () {
        if (this.model.dosage !== null) {
          this.trySubmitAndEmitValue();
        }
      },
      'model.dosage': function () {
        if (this.model.tracking_id !== null) {
          this.trySubmitAndEmitValue();
        }
      }
    },
    mounted() {
      let self = this;
      self.loadData();
    },
    methods: {
      trySubmitAndEmitValue() {
        let self = this;

        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isSaving = true;
              self.$emit('onValid', self.model);
            }
            else {
              self.$emit('onValid', null);
              self.isSaving = false;
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      closeInput() {
        let self = this;
        self.isOpenInput = false;
      },
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;
      },
      loadData() {
        let self = this;
        self.loading = true;
        self.isOpenInput = false;
        MedicationApi.getUserMedications()
          .then(function (response) {
            self.medications = response.data;
            const medicationsLength = self.medications.length;
            if (medicationsLength > 0) {
              self.hasMedications = true;
              self.model.tracking_id = self.medications[0].tracking_id;
            }
            else {
              self.hasMedications = false;
            }
          });
      },
      goToSettings() {
        let self = this;
        self.$router.push({
          path: '/settings/medications'
        })
      }
    },
    computed: {
      activeLabel() {
        let self = this;
        const tracking_id = self.model.tracking_id;
        if (self.medications.length > 0) {
          return self.medications.filter(function (item) {
            return item.tracking_id === tracking_id
          })[0].unit_label;
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Medication.vue?651623e4